import { type schemaType } from '~~/shared/api/rurality/v3/users/sign-up/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/users/sign-up/paramsSchema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/users/sign-up'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = (params: paramsType): Promise<returnType> =>
  serverFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  browserFetchWrapper<paramsType, schemaType>(endpoint, params)
